import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { ChatThread } from '@lib/chat/models/chat.interface';

import { SystemUserProfile } from '@lib/core/models/system-user.interface';

import { ChatThreadComponent } from './chat-thread/chat-thread.component';

@Component({
  selector: 'chat-threads-list',
  standalone: true,
  imports: [ChatThreadComponent, TranslatePipe],
  styles: `
    :host {
      @apply h-full;
    }
  `,
  templateUrl: './chat-threads-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatThreadsListComponent {
  selectedThread = input.required<ChatThread>();
  threads = input.required<ChatThread[]>();
  unreads = input.required<Map<string, number>>();
  systemUsers = input.required<SystemUserProfile[]>();
  ownUserId = input.required<string>();

  protected readonly usersToAssignees = computed(() => {
    return this.systemUsers().map(user => ({ id: user.userId, name: user.fullName }));
  });

  openThread = output<ChatThread>();
  pinThread = output<string>();
  unpinThread = output<string>();

  getUnreadCount(threadId: string) {
    return this.unreads().get(threadId) ?? 0;
  }

  onOpenThread(thread: ChatThread) {
    this.openThread.emit(thread);
  }
}
